import {Component, EventEmitter, Input, Output} from "@angular/core";
import {DATEPICKER_FR} from "../../../../../core/constants";
import {UtilsService} from "../../../../../core/utils/utils.service";
import {ListeBesoinsDenreeDto} from "../../../../../core/dtos/liste-besoins-denree-dto";
import {FermeturePoncutelleService} from "../../../../../core/services/entities/fermeture-poncutelle.service";
import {FermeturePonctuelleDTO} from "../../../../../core/dtos/fermeture-ponctuelle/FermeturePonctuelleDTO";
import {ButtonThemeEnum} from '../../../../../shared/ui/button/button-theme-enum';

@Component({
    selector: 'yo-bulk-edition-article',
    templateUrl: './bulk-edition-article.component.html',
    styleUrls: ['./bulk-edition-article.component.scss'],
    standalone: false
})

export class BulkEditionArticleComponent{

  public readonly ButtonThemeEnum = ButtonThemeEnum;


  @Input() displayDialog: boolean;
  @Input() selectedListeBesoinsDenree : ListeBesoinsDenreeDto[];
  @Input() fermeturePonctuelleList : FermeturePonctuelleDTO[];
  @Output() onClose = new EventEmitter<boolean>();
  @Output() emitBulk = new EventEmitter<BulkArticleSupplier>()

  localeFr = DATEPICKER_FR;

  dateSortie : Date = undefined;
  dateConso : Date = undefined;
  dateFab : Date =undefined;
  dateAppro : Date = undefined;
  dateLiv : Date = undefined;

  besoinAjuste: number;

  constructor(public utils :UtilsService,
              public fermeturePonctuelleSvc: FermeturePoncutelleService){}

  closeDialog(){
    this.displayDialog = false;
    this.onClose.emit();
    this.clearData();
  }

  sendBulkBesoinSupplier(){
    let bulkArticle : BulkArticleSupplier = new BulkArticleSupplier()
    bulkArticle.dateSortie = this.dateSortie;
    bulkArticle.dateConso = this.dateConso;
    bulkArticle.dateFab = this.dateFab;
    bulkArticle.dateAppro = this.dateAppro;
    bulkArticle.dateLiv = this.dateLiv;

    bulkArticle.besoinAjuste = this.besoinAjuste;

    this.emitBulk.emit(bulkArticle);
    this.displayDialog = false;
    this.onClose.emit();
    this.clearData();
  }

  isDisabledSaveBtn(){
    return  this.dateSortie === undefined && this.dateConso === undefined
      && this.dateFab === undefined && this.dateAppro === undefined
      && this.dateLiv === undefined && this.besoinAjuste === undefined;
  }

  clearData(){
    this.dateSortie  = undefined;
    this.dateConso  = undefined;
    this.dateFab = undefined;
    this.dateAppro  = undefined;
    this.dateLiv = undefined;
    this.besoinAjuste  = undefined;
  }

  disabledDates = (data: { date: Date }) => this.fermeturePonctuelleSvc.isDateOnFermeturePonctuelle(data.date, this.fermeturePonctuelleList);

  onUpdateDateLiv($event: any) {
    this.dateLiv = $event.value
  }
  onUpdateDateAppro($event: any) {
    this.dateAppro = $event.value
  }
}

export class BulkArticleSupplier {

  dateSortie : Date = undefined;
  dateConso : Date = undefined;
  dateFab : Date = undefined;
  dateAppro : Date = undefined;
  dateLiv : Date = undefined;

  besoinAjuste: number = undefined;
}
